module.exports = __webpack_public_path__ + "9a6fb6f5cd3aa4ab1adaaab1f693f266.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Rubik/Rubik-Bold.ttf
// module id = 1260
// module chunks = 0